import { render, staticRenderFns } from "./EditObjectIcon.vue?vue&type=template&id=1c5ea92c&"
import script from "./EditObjectIcon.vue?vue&type=script&lang=js&"
export * from "./EditObjectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports